module.exports = __webpack_public_path__ + "static/media/arrow_down.d85d080b.svg";